<template>
	<div>
		<cols-row md="2">
			<smart-input :label="$t('pages.orderTable.orderNum')" v-model="searchObj.order_num"/>
			<clients-select v-if="!(isClient || isSurveyor)" v-model="searchObj.client_id"/>
			<branches-select v-if="!(isClient || isSurveyor)" :lazy="true" :filters="{client_id: searchObj.client_id}" v-model="searchObj.branch_id"/>
			<surveyor-select v-if="!(isSurveyor )" v-model="searchObj['surveyor[]']" :label="$t('pages.orderFilter.survyers')"/>
			<v-text-field clearable type="text" :label="$t('pages.orderFilter.clientName')" v-model="searchObj.ordersCustomer"/>
			<v-text-field clearable type="text" label="שם פרוייקט" v-model="searchObj.project_name"/>
		</cols-row>
		<cols-row md="2">
			<recheck-select v-model="searchObj.recheck" v-if="!isClient"/>

			<status-select :plus="true" :hideDuplicate="true" v-model="searchObj['status[]']"/>
			<cites-select v-model="searchObj.city"/>
			<v-text-field clearable v-if="!isSurveyor" type="date" :label="$t('pages.orderFilter.dateFrom')" v-model="searchObj.startCreatedAt"/>
			<v-text-field clearable v-if="!isSurveyor" type="date" :label="$t('pages.orderFilter.dateEnds')" v-model="searchObj.endCreatedAt"/>

			<v-text-field clearable type="date" :label="$t('pages.orderFilter.matchedTo')" v-model="searchObj.beginStartDate"/>
			<v-text-field clearable type="date" :label="$t('pages.orderFilter.dateEnds')" v-model="searchObj.untilStartDate"/>

			<v-text-field clearable type="date" :label="$t('pages.orderFilter.measured')" v-model="searchObj.beginEndDate"/>
			<v-text-field clearable type="date" :label="$t('pages.orderFilter.dateEnds')" v-model="searchObj.untilEndDate"/>
			<v-btn-toggle dense class="mt-2">
				<v-btn color="primary" class="mx-md-1" @click="searchMonth(1,'days')">{{$t("pages.orderFilter.lastDay")}}</v-btn>
				<v-btn color="primary" class="mx-md-1" @click="searchMonth(7,'days')">{{$t("pages.orderFilter.lastWeek")}}</v-btn>
				<v-btn color="primary" class="mx-md-1" @click="searchMonth(1,'month')">{{$t("pages.orderFilter.lastMonth")}}</v-btn>
				<v-btn color="primary" class="mx-md-1" @click="searchMonth(1,'year')">{{$t("pages.orderFilter.lastYear")}}</v-btn>
			</v-btn-toggle>
		</cols-row>

		<cols-row md="2">
			<v-btn large left color="success" class="mx-auto" @click="sendParamSearch">{{$t("pages.orderFilter.search")}}</v-btn>
			<v-btn large left color="info" class="mx-auto" @click="clearForm">{{$t("pages.orderFilter.clearSearch")}}</v-btn>
			<v-checkbox class="ma-auto"
				v-model="searchObj.Deleted"
				:label="$t('attributes.archive')"
				@change="showArchive"
			/>
			<v-checkbox class="ma-auto"
				v-model="searchObj.urgent"
				label="מדידות דחופות"
			/>
		</cols-row>


	</div>
</template>

<script>
	import StatusSelect from "dev/view/measurements/StatusSelect";
	import ClientsSelect from "dev/view/clients/ClientsSelect";
	import BranchesSelect from "dev/view/branches/BranchesSelect";
	import SurveyorSelect from "dev/view/users/SurveyorSelect";
	import moment from "moment";
	import RecheckSelect from "dev/view/orders/RecheckSelect";
	import CitesSelect from "dev/view/measurements/CitesSelect";
	import {types} from "dev/helpers/StatusManager";

	export default {
		name: "order-filter",
		props: ["value"],
		components: {CitesSelect, RecheckSelect, SurveyorSelect, BranchesSelect, ClientsSelect, StatusSelect},
		data() {
			return {
				archive: false,
				searchObj: {
					order_num: null,
					company_name: null,
					company_branch: null,
					"status[]": [],
					"surveyor[]": [],
					branches: null,
					startCreatedAt: null,
					endCreatedAt: null,
					beginStartDate: null,
					untilStartDate: null,
					beginEndDate: null,
					untilEndDate: null,
					clientName: null,
					recheck: null,
					city: null,
					ordersCustomer: null,
					Deleted: null,
					urgent: 0,
					project_name: ""
				}
			};
		},
		watch: {
			value: {
				deep: true,
				immediate: true,
				handler() {
					this.searchObj = Object.assign({}, this.searchObj, this.value);
				}
			}
		},

		computed: {
			isSurveyor() {
				return this.$store.getters.isSurveyor;
			},
			isClient() {
				return this.$store.getters.isClient;
			},
		},
		methods: {

			changeStatus(item) {
				Object.assign(this.searchObj.status, item.status);
			},
			searchMonth(days, unit) {
				this.searchObj.startCreatedAt = moment().subtract(days, unit).format("YYYY-MM-DD");
				this.searchObj.endCreatedAt = moment(Date.now()).format("YYYY-MM-DD");
				this.sendParamSearch();
			},
			clearForm() {
				this.searchObj = {
					ordersCustomer: null,
					order_num: null,
					company_name: null,
					company_branch: null,
					"status[]": [],
					"surveyor[]": [],
					branches: null,
					startCreatedAt: null,
					endCreatedAt: null,
					beginStartDate: null,
					untilStartDate: null,
					beginEndDate: null,
					untilEndDate: null,
					city: null,
				};
				this.sendParamSearch();
			},
			sendParamSearch() {

				let filters = {};

				if (this.isClient) {
					let incSch = this.searchObj["status[]"].includes(types.SCHEDULING);
					let incNoSch = this.searchObj["status[]"].includes(types.NO_SCHEDULING);
					let indexNoSch = this.searchObj["status[]"].find(item => item === types.NO_SCHEDULING);

					if (incSch && !incNoSch) {
						this.searchObj["status[]"].push(types.NO_SCHEDULING);
					}
					if (!incSch) {
						if (incNoSch) {
							this.searchObj["status[]"].splice(indexNoSch, 1);
						}
					}
				}
				Object.keys(this.searchObj).forEach((key) => {
					if (!!this.searchObj[key]) {
						filters[key] = this.searchObj[key];
					}
				});
				this.$emit("input", filters);

			},

			showArchive() {
				// this.searchObj.Deleted = this.archive;
				this.sendParamSearch();
			}
		},
		created() {
			// if (this.$route.query.Deleted) {
			// 	this.archive = true;
			// 	this.searchObj.Deleted = true;
			// }
		}
	};
</script>

<style scoped>
	.row {
		padding: 0;
		margin: 0;
		/*height: 15px !important;*/
	}
</style>
